import { render, staticRenderFns } from "./TournamentTeamEdit.vue?vue&type=template&id=03f4d6d0&scoped=true&"
import script from "./TournamentTeamEdit.vue?vue&type=script&lang=js&"
export * from "./TournamentTeamEdit.vue?vue&type=script&lang=js&"
import style0 from "./TournamentTeamEdit.vue?vue&type=style&index=0&id=03f4d6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f4d6d0",
  null
  
)

component.options.__file = "TournamentTeamEdit.vue"
export default component.exports